/*
 * Cordial-IA 2026-10-11 - Page d'accueil premium (prototype concept-22 v12).
 * Un seul fichier pour toutes les sections cordial-home-*. Charge en defer par chaque
 * section (le navigateur ne le telecharge qu'une fois) : la garde ci-dessous empeche
 * toute double execution. Aucun commentaire en fin de ligne (piege releve le 11/10).
 * Cordial-IA 2026-10-27 - Allegement sans changement visible : textes et variables ecrits seulement s'ils changent,
 * boucle des recettes active seulement a l'ecran, travaux hors premier ecran (recettes doublees, avis, parallaxe,
 * barre d'achat) repousses en temps libre ou a l'apparition. Apparence et choregraphie inchangees.
 */
(() => {
  if (window.__cordialHome) return;
  window.__cordialHome = true;

  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const ROUTE = (p) => ROOT.replace(/\/$/, '') + p;
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => [...(r || document).querySelectorAll(s)];
  const idle = (fn) => ('requestIdleCallback' in window) ? requestIdleCallback(fn, { timeout: 2000 }) : setTimeout(fn, 300);

  /* hauteur de l'en-tete du theme : le premier ecran occupe le reste de la fenetre */
  const setHeaderVar = () => {
    const main = document.getElementById('MainContent');
    if (!main) return;
    const h = Math.max(0, Math.round(main.getBoundingClientRect().top + scrollY));
    document.documentElement.style.setProperty('--ch-hh', h + 'px');
  };

  /* ------------------------------------------------------------------ premier ecran */
  const hero = $('.ch-hero');
  let autoOn = false;
  let autoStopped = false;
  let autoDelay = 1200;
  let reveal = () => {};

  if (hero) {
    const dataEl = $('[data-ch-saveurs]', hero);
    let SAV = [];
    try { SAV = JSON.parse(dataEl.textContent); } catch (e) { SAV = []; }
    const N = SAV.length;
    let cur = 0;
    let busy = false;
    const stage = $('.ch-stage', hero);
    const dots = $('.ch-dots', hero);
    const fill = $('.ch-fill', hero);
    const base = $('.ch-base', hero);
    const sealText = $('.ch-sealt textPath', hero);
    const nowEl = $('.ch-now', hero);
    const notesEl = $('.ch-notes', hero);

    /* Cordial-IA 2026-10-12 (recette B1) : bouteilles et pastilles sont deja dans le HTML (rendu Liquid) ;
       on ne les cree que si la section est ancienne (secours), puis on branche les pastilles */
    const ssr = !!stage.querySelector('.ch-bottle');
    SAV.forEach((s, i) => {
      const old = dots.children[i];
      if (ssr && old) { old.addEventListener('click', () => userPick(i)); return; }
      const b = document.createElement('div');
      b.className = 'ch-bottle bottle' + (i === 0 ? ' on' : '');
      b.dataset.k = s.k;
      const im = document.createElement('img');
      im.src = s.img;
      im.alt = s.alt;
      im.width = s.w;
      im.height = s.h;
      im.decoding = 'async';
      if (i) im.loading = 'lazy'; else im.setAttribute('fetchpriority', 'high');
      b.appendChild(im);
      stage.appendChild(b);
      const d = document.createElement('button');
      d.type = 'button';
      d.className = 'ch-dot dot';
      d.innerHTML = '<i></i>';
      d.style.setProperty('--c', s.c);
      d.setAttribute('aria-label', s.n);
      d.setAttribute('aria-pressed', i === 0);
      d.addEventListener('click', () => userPick(i));
      dots.appendChild(d);
    });

    const texts = (s, i) => {
      if (nowEl) nowEl.textContent = s.n;
      if (notesEl) notesEl.textContent = s.notes;
      if (sealText) sealText.textContent = (s.notes + ' · ' + s.n + ' · ').repeat(2);
      $$('.ch-dot', hero).forEach((d, j) => d.setAttribute('aria-pressed', j === i));
    };
    const setAccent = (s) => {
      document.documentElement.style.setProperty('--ch-accent', s.c);
    };
    if (N) {
      setAccent(SAV[0]);
      base.style.setProperty('--c', SAV[0].c);
      texts(SAV[0], 0);
    }

    function pick(i) {
      if (i === cur || busy || !N) return;
      busy = true;
      const s = SAV[i];
      cur = i;
      hero.classList.add('ch-swapped');
      setAccent(s);
      const old = $('.ch-bottle.on', hero);
      const nb = $('.ch-bottle[data-k="' + s.k + '"]', hero);
      fill.style.setProperty('--c', s.c);
      if (old) { old.classList.add('ch-out'); old.classList.remove('on'); }
      nb.classList.add('ch-in');
      void nb.offsetWidth;
      fill.classList.remove('ch-go');
      void fill.offsetWidth;
      fill.classList.add('ch-go');
      nb.classList.remove('ch-in');
      nb.classList.add('on');
      setTimeout(() => {
        base.style.setProperty('--c', s.c);
        fill.classList.remove('ch-go');
        if (old) old.classList.remove('ch-out');
      }, 1380);
      setTimeout(() => texts(s, i), 250);
      setTimeout(() => { busy = false; }, 1420);
    }

    /* defilement automatique toutes les 5 s, en pause au survol et quand la page est cachee */
    let autoT = null;
    let autoLeft = 5000;
    let autoStart = 0;
    const autoBtn = $('.ch-autobtn', hero);
    const syncAutoBtn = () => {
      if (!autoBtn) return;
      autoBtn.setAttribute('aria-pressed', autoOn);
      autoBtn.textContent = autoOn ? autoBtn.dataset.on : autoBtn.dataset.off;
    };
    const restartRing = () => {
      hero.classList.remove('ch-auto');
      void hero.offsetWidth;
      if (autoOn) hero.classList.add('ch-auto');
    };
    const armAuto = (ms) => {
      clearTimeout(autoT);
      autoStart = performance.now();
      autoLeft = ms;
      autoT = setTimeout(() => { pick((cur + 1) % N); restartRing(); armAuto(5000); }, ms);
    };
    const startAuto = () => {
      if (RM || N < 2) return;
      autoOn = true;
      restartRing();
      armAuto(5000);
      syncAutoBtn();
    };
    const stopAuto = () => {
      autoOn = false;
      clearTimeout(autoT);
      hero.classList.remove('ch-auto', 'ch-paused');
      syncAutoBtn();
    };
    const pauseAuto = (p) => {
      if (!autoOn) return;
      hero.classList.toggle('ch-paused', p);
      if (p) {
        clearTimeout(autoT);
        autoLeft = Math.max(300, autoLeft - (performance.now() - autoStart));
      } else {
        armAuto(autoLeft);
      }
    };
    function userPick(i) {
      autoStopped = true;
      stopAuto();
      pick(((i % N) + N) % N);
    }
    $$('.ch-arr', hero).forEach((a) => a.addEventListener('click', () => userPick(cur + Number(a.dataset.dir))));
    /* pause au survol (souris) du medaillon et du selecteur seulement, pas de toute la section (11/10 soir) ; au toucher, choisir une saveur arrete le defilement */
    $$('.ch-medwrap,.ch-picker', hero).forEach((z) => {
      z.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') pauseAuto(true); });
      z.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') pauseAuto(false); });
    });
    /* mobile : le medaillon se dimensionne sur l'espace libre entre le texte et le selecteur */
    const medwrap = $('.ch-medwrap', hero);
    const med = $('.ch-med', hero);
    if (medwrap && med && 'ResizeObserver' in window) {
      let lastMh = '', lastMw = '';
      const ro = new ResizeObserver(() => {
        const mh = Math.round(medwrap.getBoundingClientRect().height) + 'px';
        const mw = Math.round(med.getBoundingClientRect().width) + 'px';
        if (mh !== lastMh) { lastMh = mh; hero.style.setProperty('--ch-mh', mh); }
        if (mw !== lastMw) { lastMw = mw; hero.style.setProperty('--ch-mw', mw); }
      });
      ro.observe(medwrap);
      ro.observe(med);
    }
    document.addEventListener('visibilitychange', () => pauseAuto(document.hidden));
    if (autoBtn) {
      autoBtn.addEventListener('click', () => {
        if (autoOn) { autoStopped = true; stopAuto(); } else { autoStopped = false; startAuto(); }
      });
    }
    addEventListener('load', () => setTimeout(() => {
      $$('.ch-bottle img[loading="lazy"]', hero).forEach((im) => { im.loading = 'eager'; });
    }, 1500));

    /* Cordial-IA 2026-10-13 (entree) : .ch-ready lance l'animation d'entree du premier ecran ; deja posee par le script
       en ligne de la section quand le rideau ne se joue pas. Deux images d'attente : les transitions partent toujours
       d'un etat de depart deja peint. */
    reveal = () => {
      if (!hero.classList.contains('ch-ready')) requestAnimationFrame(() => requestAnimationFrame(() => hero.classList.add('ch-ready')));
      if (hero.dataset.auto === 'true' && !autoOn && !autoStopped) setTimeout(startAuto, autoDelay);
    };
  }

  /* ------------------------------------------------------------------ ecran de chargement */
  /* Cordial-IA 2026-10-11 - lot 0 : layout/theme.liquid pose html.ch-wait (tout masque sauf le rideau) ; on la retire ici au lever du rideau */
  const unwait = () => document.documentElement.classList.remove('ch-wait');
  const loader = document.getElementById('ch-loader');
  if (!loader || !hero) unwait();
  if (loader && hero) {
    const pour = $('video', loader);
    const n = $('.ch-n', loader);
    let seen = false;
    try { seen = sessionStorage.getItem('cordial-intro') === '1'; } catch (e) { seen = false; }
    const force = location.hash === '#intro';
    /* Cordial-IA 2026-10-12 - rideau pilote par la video : le clip de versement est joue en entier, accelere
       (playbackRate) pour durer ~1,8 s ; le pourcentage = currentTime / duration, mis a jour a chaque image ;
       pause de 0,3 s sur la derniere image (verre plein decore) pendant laquelle % et signature s'effacent,
       puis le panneau monte en 1 s avec le dessin imprime dessus. Securite : video impossible ou trop lente
       (4 s) = derniere image + 100 % et ouverture. */
    const RATE = (window.chIntro && window.chIntro.rate) || 1.9;
    const run = (reduced) => {
      let started = false;
      let finished = false;
      let shown = -1;
      const show = (v) => { const x = Math.max(0, Math.min(100, Math.round(v))); if (x !== shown) { shown = x; n.textContent = x; } };
      const toLastFrame = () => {
        if (!pour) return;
        try {
          pour.pause();
          if (!pour.ended && pour.duration && isFinite(pour.duration)) pour.currentTime = Math.max(0, pour.duration - 0.05);
        } catch (e) { /* lecture impossible : le poster reste affiche */ }
      };
      const finish = () => {
        if (finished) return;
        finished = true;
        clearTimeout(safety);
        toLastFrame();
        show(100);
        setTimeout(() => {
          /* temps 1 : pause visible sur la derniere image, % et signature s'effacent en 0,3 s (le dessin reste) */
          loader.classList.add('ch-fade');
          unwait();
          setTimeout(() => {
            /* temps 2 : le panneau coulisse vers le haut en 1 s, le dessin imprime dessus */
            loader.classList.add('ch-out');
            /* Cordial-IA 2026-10-13 (entree, decision Anthony) : le premier ecran se met en place sous les yeux pendant la montee du rideau */
            autoDelay = 2000;
            reveal();
            setTimeout(() => { loader.hidden = true; }, 1100);
          }, 320);
        }, 300);
      };
      const safety = setTimeout(finish, reduced ? 800 : 4000);
      /* Cordial-IA 2026-10-12 (option A) : seuil depasse pendant l'attente = le script en ligne de la section
         efface deja le rideau ; ici on arrete tout et on revele la page sans transition d'entree */
      loader.addEventListener('ch-skip', () => {
        if (finished) return;
        finished = true;
        clearTimeout(safety);
        /* Cordial-IA 2026-10-13 (entree) : chIntro.skip a deja pose .ch-ready, l'entree se joue pendant le fondu */
        reveal();
      }, { once: true });
      if (!pour) { finish(); return; }
      pour.addEventListener('ended', finish);
      pour.addEventListener('error', finish);
      if (reduced) {
        /* mouvement reduit : pas de versement, derniere image fixe */
        const still = () => { toLastFrame(); show(100); setTimeout(finish, 200); };
        if (pour.readyState >= 1) still(); else pour.addEventListener('loadedmetadata', still, { once: true });
        return;
      }
      const update = () => {
        if (finished) return;
        const d = pour.duration;
        if (d && isFinite(d)) show(pour.currentTime / d * 100);
      };
      const loop = () => {
        if (finished) return;
        update();
        if (pour.ended || (pour.duration && pour.currentTime >= pour.duration - 0.02)) { finish(); return; }
        requestAnimationFrame(loop);
      };
      if ('requestVideoFrameCallback' in pour) {
        const onFrame = () => { if (finished) return; update(); pour.requestVideoFrameCallback(onFrame); };
        pour.requestVideoFrameCallback(onFrame);
      }
      /* Cordial-IA 2026-10-13 (rideau iPhone) : Safari iOS ne precharge jamais au-dela des metadonnees
         (WebKit : MediaDataLoadsAutomatically = false sur iOS), donc canplay n'arrive qu'apres play() :
         attendre readyState >= 3 faisait sauter le rideau a chaque visite sur iPhone. La lecture est demandee
         des le parsing par le script en ligne de la section (promesse chIntro.p) ; elle se resout quand les
         images defilent vraiment, et c'est ce moment qui verrouille le rideau (option A du 12/10 inchangee). */
      const ci = window.chIntro;
      const start = () => {
        if (started || finished) return;
        /* option A : la lecture ne compte que si le seuil n'est pas depasse ; elle verrouille le rideau */
        if (ci) { if (ci.s === 'skip') return; ci.s = 'play'; }
        started = true;
        pour.playbackRate = RATE;
        if (pour.paused) { const pl = pour.play(); if (pl && pl.catch) pl.catch(bail); }
        requestAnimationFrame(loop);
      };
      /* lecture refusee (economie d'energie iOS, lecture automatique bloquee) : pas de rideau, fondu immediat vers le site */
      const bail = () => {
        if (started || finished) return;
        if (ci && ci.s === 'skip') return;
        if (ci && ci.skip) ci.skip(); else finish();
      };
      let pl = ci && ci.p;
      if (!pl) { try { pour.playbackRate = RATE; pl = pour.play(); } catch (e) { pl = null; } }
      /* l'evenement playing arrive parfois avant la resolution de la promesse (WebKit : ~170 ms) ; start est idempotent */
      pour.addEventListener('playing', start, { once: true });
      if (pl && pl.then) pl.then(start, bail);
      else if (pour.readyState >= 3) start();
      else {
        pour.addEventListener('canplay', start, { once: true });
        pour.addEventListener('canplaythrough', start, { once: true });
      }
    };
    /* Cordial-IA 2026-10-12 (recette C5) : mouvement reduit = pas de rideau du tout (le style de theme.liquid le masque deja) */
    /* Cordial-IA 2026-10-12 (option A) : seuil deja depasse quand ce script arrive = rideau deja efface par la section */
    if (window.chIntro && window.chIntro.s === 'skip') {
      loader.hidden = true;
      unwait();
      reveal();
    } else if ((seen && !force) || RM) {
      loader.hidden = true;
      unwait();
      reveal();
    } else {
      try { sessionStorage.setItem('cordial-intro', '1'); } catch (e) { /* stockage indisponible */ }
      run(false);
    }
  } else if (hero) {
    reveal();
  }

  /* ------------------------------------------------------------------ apparitions au defilement */
  (() => {
    const cards = $$('.ch-card');
    const els = $$('.ch-rv,.ch-prep,.ch-prom,.ch-cmp');
    if (RM || !('IntersectionObserver' in window)) {
      cards.forEach((c) => c.classList.add('ch-vu'));
      els.forEach((e) => e.classList.add('ch-vu'));
      return;
    }
    const ioCards = new IntersectionObserver((es) => es.forEach((e) => {
      if (!e.isIntersecting) return;
      const i = cards.indexOf(e.target);
      e.target.style.transitionDelay = (i % 3) * 0.1 + 's';
      e.target.classList.add('ch-vu');
      ioCards.unobserve(e.target);
    }), { rootMargin: '0px 0px -10% 0px' });
    cards.forEach((c) => ioCards.observe(c));
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      if (!e.isIntersecting) return;
      const el = e.target;
      if (el.classList.contains('ch-rv')) {
        const sib = [...el.parentElement.children].filter((x) => x.classList.contains('ch-rv'));
        el.style.transitionDelay = Math.min(sib.indexOf(el), 4) * 0.09 + 's';
      }
      el.classList.add('ch-vu');
      io.unobserve(el);
    }), { rootMargin: '0px 0px -12% 0px' });
    els.forEach((e) => io.observe(e));
    $$('.ch-cmp tbody tr').forEach((tr, i) => { tr.style.transitionDelay = (0.15 + i * 0.07) + 's'; });
  })();

  /* ------------------------------------------------------------------ videos "Comment preparer" */
  (() => {
    const vs = $$('.ch-prep video');
    if (!vs.length || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      const v = e.target;
      if (e.isIntersecting) {
        if (!v.src && v.dataset.src) v.src = v.dataset.src;
        if (!RM) { const p = v.play(); if (p && p.catch) p.catch(() => {}); }
      } else {
        v.pause();
      }
    }), { threshold: 0.35 });
    vs.forEach((v) => io.observe(v));
  })();

  /* ------------------------------------------------------------------ citations des chefs */
  (() => {
    const qs = $$('.ch-qs blockquote');
    const ds = $$('.ch-qd button');
    if (!qs.length) return;
    let i = 0;
    let t = null;
    const go = (k) => {
      i = (k + qs.length) % qs.length;
      qs.forEach((q, j) => q.classList.toggle('ch-on', j === i));
      ds.forEach((d, j) => d.setAttribute('aria-pressed', j === i));
    };
    const arm = () => { clearInterval(t); if (!RM && qs.length > 1) t = setInterval(() => go(i + 1), 6000); };
    ds.forEach((d, j) => d.addEventListener('click', () => { go(j); arm(); }));
    arm();
  })();

  /* ------------------------------------------------------------------ la maison : parallaxe douce */
  (() => {
    const d = $('.ch-mai .ch-duo');
    if (!d || RM) return;
    const m1 = $('.ch-m1 img', d);
    const m2 = $('.ch-m2', d);
    let raf = 0;
    const up = () => {
      raf = 0;
      const r = d.getBoundingClientRect();
      const h = innerHeight;
      const p = Math.min(1, Math.max(0, (h - r.top) / (h + r.height)));
      if (m1) m1.style.setProperty('--z', (1.12 - 0.12 * p).toFixed(4));
      if (m2) m2.style.setProperty('--y', (40 - 80 * p).toFixed(1) + 'px');
    };
    let vis = false;
    addEventListener('scroll', () => { if (vis && !raf) raf = requestAnimationFrame(up); }, { passive: true });
    if ('IntersectionObserver' in window) new IntersectionObserver((en) => { vis = en[0].isIntersecting; if (vis && !raf) raf = requestAnimationFrame(up); }, { rootMargin: '200px 0px' }).observe(d);
    else { vis = true; up(); }
  })();

  /* ------------------------------------------------------------------ barre d'achat mobile + hauteur en-tete */
  (() => {
    const bb = $('.ch-buybar');
    const faq = $('.ch-faq');
    let raf = 0;
    const up = () => {
      raf = 0;
      setHeaderVar();
      if (!bb || !hero) return;
      const vh = innerHeight;
      const pastHero = hero.getBoundingClientRect().bottom < vh * 0.15;
      const atEnd = faq && faq.getBoundingClientRect().top < vh * 0.6;
      const on = pastHero && !atEnd;
      bb.classList.toggle('ch-on', on);
      bb.setAttribute('aria-hidden', on ? 'false' : 'true');
      $$('a', bb).forEach((a) => { a.tabIndex = on ? 0 : -1; });
    };
    addEventListener('scroll', () => { if (document.hidden) up(); else if (!raf) raf = requestAnimationFrame(up); }, { passive: true });
    addEventListener('resize', up);
    raf = requestAnimationFrame(up);
  })();

  /* ------------------------------------------------------------------ ajout au panier (reel) + animation */
  (() => {
    const btns = $$('.ch-card .ch-add');
    if (!btns.length) return;
    const cartLink = $('.site-header__cart-toggle') || $('a[href*="/cart"]');
    const bubbles = () => $$('.cart-item-count-header--quantity');
    const announce = (msg) => {
      const live = $('.ch-live');
      if (live) { live.textContent = ''; setTimeout(() => { live.textContent = msg; }, 30); }
    };
    const fly = (img, done) => {
      if (RM || !img || !cartLink) { done(); return; }
      const a = img.getBoundingClientRect();
      const b = cartLink.getBoundingClientRect();
      const f = img.cloneNode();
      f.className = 'ch-fly';
      f.removeAttribute('loading');
      f.setAttribute('aria-hidden', 'true');
      Object.assign(f.style, { left: a.left + 'px', top: a.top + 'px', width: a.width + 'px', height: a.height + 'px' });
      document.body.appendChild(f);
      requestAnimationFrame(() => {
        const dx = b.left + b.width / 2 - (a.left + a.width / 2);
        const dy = b.top + b.height / 2 - (a.top + a.height / 2);
        f.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(.12) rotate(18deg)';
        f.style.opacity = '.2';
      });
      setTimeout(() => { f.remove(); done(); }, 820);
    };
    const pulse = (cart) => {
      bubbles().forEach((b) => {
        if (cart && typeof cart.item_count === 'number') { b.textContent = cart.item_count; b.classList.toggle('hide', cart.item_count === 0); }
        b.classList.remove('ch-pulse');
        void b.offsetWidth;
        b.classList.add('ch-pulse');
      });
      if (cartLink && cart && cart.item_count > 0) cartLink.classList.add('cart-count-visible');
    };
    btns.forEach((btn) => btn.addEventListener('click', async () => {
      if (btn.getAttribute('aria-busy') === 'true') return;
      const card = btn.closest('.ch-card');
      const img = $('.ch-bt img', card);
      const err = $('.ch-err', card);
      const labelIdle = btn.dataset.idle || btn.textContent;
      const labelBusy = btn.dataset.busy || labelIdle;
      const labelOk = btn.dataset.ok || labelIdle;
      const id = btn.dataset.variant;
      if (err) err.hidden = true;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = labelBusy;
      try {
        const res = await fetch(ROUTE('/cart/add.js'), {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: 'cart-drawer' }),
        });
        if (!res.ok) throw new Error('add');
        const json = await res.json();
        btn.removeAttribute('aria-busy');
        btn.classList.add('ch-ok');
        btn.textContent = labelOk;
        announce((btn.dataset.name || '') + ' ' + labelOk.toLowerCase().replace(/\s*✓$/, ''));
        setTimeout(() => { btn.classList.remove('ch-ok'); btn.textContent = labelIdle; }, 1500);
        fly(img, async () => {
          /* le tiroir natif se met a jour sans s'ouvrir ; la bulle de l'en-tete suit (cordial-cart-count.js) */
          if (window.eventBus) window.eventBus.emit('update:cart:drawer', json);
          try {
            const c = await fetch(ROUTE('/cart.js'), { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
            if (c.ok) {
              const cart = await c.json();
              pulse(cart);
              document.documentElement.dispatchEvent(new CustomEvent('wetheme-cart-update', { detail: { cart } }));
            }
          } catch (e) { pulse(null); }
        });
      } catch (e) {
        btn.removeAttribute('aria-busy');
        btn.textContent = labelIdle;
        if (err) { err.hidden = false; }
        announce(err ? err.textContent : '');
      }
    }));
  })();

  /* ------------------------------------------------------------------ recettes : rangee doublee pour la boucle */
  (() => {
    const row = $('.ch-rec .ch-row');
    if (!row || RM) return;
    idle(() => [...row.children].forEach((c) => {
      const d = c.cloneNode(true);
      d.setAttribute('aria-hidden', 'true');
      d.tabIndex = -1;
      row.appendChild(d);
    }));
  })();

  /* ------------------------------------------------------------------ recettes : glissables au doigt (16/10, demande Anthony)
     Ecrans tactiles seulement : la rangee devient un vrai defilement horizontal, avance seule (meme vitesse que l'animation : 70 s
     pour une moitie), se met en pause pendant le toucher et 3 s apres, boucle sans fin grace a la rangee doublee. Ordinateur inchange. */
  (() => {
    const sec = $('.ch-rec');
    const row = sec && $('.ch-row', sec);
    if (!row || RM || !matchMedia('(hover: none)').matches) return;
    sec.classList.add('ch-rec-swipe');
    let half = 0, last = 0, acc = 0, holdUntil = 0, visible = true;
    const measure = () => { half = row.scrollWidth / 2; };  // la rangee elle-meme defile (titre et bouton restent fixes)
    idle(measure);
    addEventListener('resize', measure);
    addEventListener('load', () => idle(measure));
    const hold = (ms) => { holdUntil = performance.now() + ms; };
    row.addEventListener('touchstart', () => hold(1e9), { passive: true });
    row.addEventListener('touchend', () => hold(3000), { passive: true });
    row.addEventListener('touchcancel', () => hold(3000), { passive: true });
    row.addEventListener('scroll', () => {
      if (half < 2) return;
      if (row.scrollLeft >= half) row.scrollLeft -= half;
      else if (row.scrollLeft <= 0 && holdUntil > performance.now()) row.scrollLeft += half;
    }, { passive: true });
    let loopId = 0;
    const step = (t) => {
      loopId = 0;
      if (!visible) { last = 0; return; }
      if (last && t > holdUntil && half > 2) {
        acc += (t - last) * half / 70000;
        const px = Math.floor(acc);
        if (px >= 1) { row.scrollLeft += px; acc -= px; }
      }
      last = t;
      loopId = requestAnimationFrame(step);
    };
    if ('IntersectionObserver' in window) {
      visible = false;
      new IntersectionObserver((en) => { visible = en[0].isIntersecting; if (visible && !loopId) { last = 0; if (half < 2) measure(); loopId = requestAnimationFrame(step); } }).observe(sec);
    } else loopId = requestAnimationFrame(step);
  })();

  /* ------------------------------------------------------------------ avis : vrais avis Judge.me extraits du bloc rendu, mis en piste qui defile (11/10 soir) */
  (() => {
    const sec = $('.ch-avis');
    const trk = sec && $('.ch-trk', sec);
    const host = sec && $('.ch-jdgm', sec);
    if (!sec || !trk || !host) return;
    let done = false;
    const build = () => {
      if (done) return;
      const cards = $$('.jdgm-card, .jdgm-carousel-item, .jdgm-rev', host);
      if (!cards.length) return;
      const seen = new Set();
      const items = [];
      cards.forEach((c) => {
        const txt = ($('.jdgm-text p, .jdgm-text, .jdgm-rev__body', c) || {}).textContent || '';
        const name = ($('.jdgm-reviewer-name, .jdgm-rev__author', c) || {}).textContent || '';
        const stars = $$('.jdgm-star.jdgm--on, .jdgm-star.jdgm--full', c).length;
        const key = txt.trim() + '|' + name.trim();
        if (!txt.trim() || seen.has(key)) return;
        seen.add(key);
        items.push({ txt: txt.trim(), name: name.trim(), stars: stars || 5 });
      });
      if (!items.length) return;
      done = true;
      const card = (it, hidden) => {
        const a = document.createElement('article');
        a.className = 'ch-av';
        if (hidden) a.setAttribute('aria-hidden', 'true');
        const s = document.createElement('span');
        s.className = 'ch-stars';
        s.textContent = '\u2605'.repeat(it.stars) + '\u2606'.repeat(Math.max(0, 5 - it.stars));
        s.setAttribute('aria-label', (sec.dataset.starsLabel || '[n] étoiles sur 5').replace('[n]', it.stars));
        const p = document.createElement('p');
        p.textContent = it.txt;
        const b = document.createElement('b');
        b.textContent = it.name;
        a.append(s, p, b);
        return a;
      };
      items.forEach((it) => trk.appendChild(card(it, false)));
      if (!RM) items.forEach((it) => trk.appendChild(card(it, true)));
      trk.hidden = false;
      sec.classList.add('ch-avis--live');
      sec.dataset.avisCount = items.length;
    };
    idle(() => {
    build();
    if (!done && 'MutationObserver' in window) {
      const mo = new MutationObserver(() => { build(); if (done) mo.disconnect(); });
      mo.observe(host, { childList: true, subtree: true });
      setTimeout(() => mo.disconnect(), 20000);
    }
    });
  })();

  /* ------------------------------------------------------------------ bandeaux : pause au toucher (survol et focus clavier : CSS) ; plus aucun bouton (decision Anthony 11/10) */
  $$('.ch-band,.ch-trust,.ch-rec,.ch-avis').forEach((sec) => {
    let t = null;
    sec.addEventListener('pointerdown', (e) => { if (e.pointerType === 'mouse') return; sec.classList.add('ch-touch'); clearTimeout(t); });
    const off = () => { clearTimeout(t); t = setTimeout(() => sec.classList.remove('ch-touch'), 2000); };
    sec.addEventListener('pointerup', off);
    sec.addEventListener('pointercancel', off);
  });

  setHeaderVar();
  addEventListener('load', setHeaderVar);
})();
